import { INSTITUT_ROUTES as institutRoutes } from "~/api/routes";
import {generateOptions, setLoggedUser} from "~/helpers";
export const state = () => ({
  instituts: [],
  details: [],
  institutPrestations: [],

  close:false,
  isRequesting:false
});
export const getters = {
  optionsInstituts: (state) => {
    try {
      if (state.instituts)
        return generateOptions(state.instituts);
    } catch (e) {
    }
  },
  getSelectedInstituts: (state, getters) => (instituts) => {
    return getters.optionsInstituts.filter(elem => instituts.find(y => y === elem.item.institut_id))
  },
  getinstitutPrestations:(state)=>{
   return state.institutPrestations;
  }
};
export const mutations = {
  INSTITUTS_LOAD(state) {
    //state.isLoading = true;
    state.hasError = false;
    state.instituts = [];
    //state.page = page;
  },
  INSTITUTS_SUCCES(state, instituts) {
    state.instituts = instituts;
    //state.pagination = params.payload.pagination;
    //state.filters = params.filters || state.filters;
  },
  INSTITUTS_ERROR(state) {
    state.instituts = [];
    state.hasError = true;
  },
  INSTITUTS_LOADED(state) {
    //state.isLoading = false;
  },
  INSTITUT_PROCESSING_START(state) {
    //state.isLoading = false;
  },
  INSTITUT_PROCESSING_END(state) {
    //state.isLoading = false;
  },
  INSTITUT_SUCCES(state,details) {
    state.details = details;
    //state.isLoading = false;
  },
  INSTITUT_PRESTATION_SUCCES(state,data) {
    state.institutPrestations = data;
    //state.isLoading = false;
  },
  INSTITUT_ERROR(state) {
    //state.isLoading = false;
  },
  REMOVE_INSTITUT_FROM_LIST(state, institut) {
    let user = JSON.parse(localStorage.getItem('_USER'));
    user.instituts = user.instituts.filter(element => element.institut_id !== institut.institut_id);
    setLoggedUser(user);
    state.instituts = state.instituts.filter(element => element.institut_id !== institut.institut_id);
  },
  UPDATE_AN_INSTITUT(state, institut) {
    try{
      let index = state.instituts.findIndex((elem) => elem.institut_id === institut.institut_id);
      state.instituts = state.instituts.filter(element => element.institut_id !== institut.institut_id);
      state.instituts.splice(index, 0, institut);
    }catch(e){
    }
  },
  CLOSE_MODAL(state,close){
    state.close = close;
  },
  IS_REQUESTING(state,isRequesting){
    state.isRequesting = isRequesting
  },
  ADD_INSTITUT_TO_LIST(state, institut) {
    try{
      let user = JSON.parse(localStorage.getItem('_USER'));
      user.instituts.unshift({  'institut_id':institut.institut_id , 'nom': institut.nom });
      setLoggedUser(user);
      state.instituts.unshift(institut);
    }catch(e){
    }
  },
  REMOVE_INSTITUT_IMAGE(state,institut_id){
    let index = state.instituts.findIndex((elem) => elem.institut_id === institut_id);
    state.instituts[index].image=null
  },
  UNLINK_INSTITUT(state,institut_id){
  let index = state.instituts.findIndex((elem) => elem.institut_id === institut_id);
  state.instituts[index].treatwell_access_token=null;
},

};

export const actions = {
  async getInstituts({ commit }) {
    commit('INSTITUTS_LOAD');
    commit('IS_REQUESTING',true);
    this.$api.request(institutRoutes.list)
      .then(response => {
        commit('INSTITUTS_SUCCES', response.payload);
      })
      .catch(error => {
        commit('INSTITUTS_ERROR');
      })
      .finally(() => {
        commit('INSTITUTS_LOADED');
        commit('IS_REQUESTING',false);
      });
  },
  async getInstitutById({commit}, params) {
    commit('INSTITUT_PROCESSING_START');
    await this.$api.request(institutRoutes.get,{id:params.institut_id})
      .then(response => {
        commit('INSTITUT_SUCCES', response.payload);
      })
      .catch(error => {
        commit('INSTITUT_ERROR');
      })
      .finally(() => commit('INSTITUT_PROCESSING_END'));
  },
  async createInstitut({ commit }, params) {
    commit('INSTITUT_PROCESSING_START');
    commit('CLOSE_MODAL',false);
    commit('IS_REQUESTING',true);
    await this.$api.request(institutRoutes.create,{}, params)
      .then(response => {
        commit('CLOSE_MODAL',true);
        commit('ADD_INSTITUT_TO_LIST', response.payload);
      })
      .catch(error => {
        commit('CLOSE_MODAL',false);
        commit('INSTITUT_ERROR');
      })
      .finally(() => {
        commit('IS_REQUESTING',false);
        commit('INSTITUT_PROCESSING_END')
      });
  },


  async createInstitutPrestation({ commit }, params) {
    commit('INSTITUT_PROCESSING_START');
    commit('CLOSE_MODAL',false);
    commit('IS_REQUESTING',true);
    await this.$api.request(institutRoutes.createPrestation,{}, params)
      .then(response => {
        commit('CLOSE_MODAL',true);
        commit('ADD_INSTITUT_TO_LIST', response.payload);
      })
      .catch(error => {
        commit('CLOSE_MODAL',false);
        commit('INSTITUT_ERROR');
      })
      .finally(() => {
        commit('IS_REQUESTING',false);
        commit('INSTITUT_PROCESSING_END')
      });
  },


  async getInstitutPrestation({commit}, params) {
    commit('INSTITUT_PROCESSING_START');
    await this.$api.request(institutRoutes.getInstitutPrestation,{institut_id:params.institut_id})
      .then(response => {
        commit('INSTITUT_PRESTATION_SUCCES', response.payload);
      })
      .catch(error => {
        commit('INSTITUT_ERROR');
      })
      .finally(() => commit('INSTITUT_PROCESSING_END'));
  },
  async updateInstitut({ commit }, params) {
    commit('INSTITUT_PROCESSING_START');
    commit('CLOSE_MODAL',false);
    commit('IS_REQUESTING',true);
    await this.$api.request(institutRoutes.update, {id: params.id}, params.formData)
      .then(response => {
        commit('CLOSE_MODAL',true);
        commit('UPDATE_AN_INSTITUT', response.payload);
      })
      .catch(error => {
        commit('CLOSE_MODAL',false);
        commit('INSTITUT_ERROR');
      })
      .finally(() => {
        commit('IS_REQUESTING',false);
        commit('INSTITUT_PROCESSING_END')
      });
  },
  async deleteInstitut({ commit }, params) {
    commit('INSTITUT_PROCESSING_START');
    await this.$api.request(institutRoutes.delete, { id: params.institut_id })
      .then(response => {
        commit('REMOVE_INSTITUT_FROM_LIST', params);
      })
      .catch(error => {
        commit('INSTITUT_ERROR');
      })
      .finally(() => commit('INSTITUT_PROCESSING_END'));
  },
  async removeImage({ commit }, params){
    commit('REMOVE_INSTITUT_IMAGE', params.id);
  },
  async unLinkInstitut({ commit }, params){
    commit('UNLINK_INSTITUT', params);
  }
};
